import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { defineCustomElements } from '@uoa/web-components/loader';

import { environment } from './environments/environment';
import { DatePipe, IMAGE_CONFIG } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { CognitoConfigService, StorageService, AuthModule } from '@uoa/auth';
import { AppAuthDesktopConfig } from './app/auth.desktop.config';
import { AppStorageService } from './app/core/services';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { AppRoutingModule } from './app/app-routing.module';
import { SelfServiceModule } from './app/pages/self-service/self-service.module';
import { WallboardsModule } from './app/pages/wallboard/wallboards.module';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AuthModule,
      IonicModule.forRoot(),
      IonicStorageModule.forRoot({
        name: '__wallboards',
        driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
      }),
      AppRoutingModule,
      SelfServiceModule,
      // SelfServiceRoutingModule,
      WallboardsModule,
      FormsModule,
      BrowserAnimationsModule,
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    DatePipe,
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
      },
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: CognitoConfigService, useClass: AppAuthDesktopConfig },
    { provide: StorageService, useClass: AppStorageService },
  ],
}).catch((err) => console.log(err));

defineCustomElements();
